import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Globals } from '../../globals';
import { Calendar } from './calendar.interface';

@Injectable({
  providedIn: 'root',
})
/**
 * Calendar REST calls
 */
export class CalendarService {
  private readonly http = inject(HttpClient);
  private readonly globals = inject(Globals);


  /**
   * Get all office calendars
   */
  getOfficeCalendars(id: number): Observable<Calendar[]> {
    const url = this.globals.calendar + `/office/list/${id}`;
    return this.http.get<Calendar[]>(url);
  }

  /**
   * Get all google calendars
   */
  getGoogleCalendars(id: number): Observable<Calendar[]> {
    const url = this.globals.calendar + `/google/list/${id}`;
    return this.http.get<Calendar[]>(url);
  }

  /**
   * Redirect to office page
   */
  getOfficeRedirectUri(): Observable<string> {
    const url = this.globals.calendar + `/office`;
    return this.http.get(url, { responseType: 'text' });
  }

  /**
   * Activate google calendar
   */
  activateGoogleCalendar(id: number, code: string): Observable<void> {
    const url =
      this.globals.calendar +
      `/google/linkv2?userId=${id}&code=${code}&qorigin=` +
      this.globals.server;
    return this.http.get<void>(url);
  }

  /**
   * Activate office calendar
   */
  activateOfficeCalendar(id: number, code: string): Observable<void> {
    const url =
      this.globals.calendar +
      `/office/linkv2?userId=${id}&code=${code}&qorigin=` +
      this.globals.server;
    return this.http.get<void>(url);
  }
}
